import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/styles';
import React from 'react';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    // backgroundColor: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    maxWidth: 1000,
    fontSize: 14
  }
}))(Tooltip);

const IconWithTooltip = ({ title, fontSize }) => {
  const iconProps = {
    fontSize,
    style: {
      marginTop: -4
    }
  };
  return (
    <LightTooltip title={title} placement="top">
      <IconButton
        aria-label="delete"
        tabIndex={-1}
        style={{ padding: 0, pointerEvents: 'auto' }}
      >
        <InfoIcon {...iconProps} />
      </IconButton>
    </LightTooltip>
  );
};

export default IconWithTooltip;
